import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './styles.module.scss';

export type FilterNavItem = {
  path: string;
  label: string;
};

const navItems: FilterNavItem[] = [
  { path: '/2025/events', label: '全ての企画' },
  { path: '/2025/events/special', label: '特別企画' },
  { path: '/2025/events/festival', label: 'かまた祭のイベント' },
  { path: '/2025/events/tut', label: '東京工科大学' },
  { path: '/2025/events/neec', label: '日本工学院専門学校' },
  { path: '/2025/events/japanese-school', label: '日本語学校' },
];

const EventFilterNav: React.FC = () => {
  return (
    <nav className={styles.filterNav}>
      <div className={styles.filterNav__container}>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/2025/events'}
            className={({ isActive }) =>
              `${styles.filterNav__link} ${isActive ? styles['filterNav__link--active'] : ''}`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default EventFilterNav;
